var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveRoad = function SvgRemoveRoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M720-160v-640h80v640zm-560 0v-640h80v640zm280-480v-160h80v160zm0 480v-160h80v160zM337.02-396.3l85-85-85-84 57-57 85 85 85-85 56 57-85 85 84 85-55 56-86-85-85 85z"
  })));
};
export default SvgRemoveRoad;